'use client'

import React from 'react'

import { Button, cn, DropdownMenuItem } from '@rewardops/ui'

import { useLocaleChange } from '~/components/hooks/use-locale-change'
import { useTranslation } from './client'

type LanguageSwitcherProps = {
  languages?: string[]
  color?: string
  menuItem?: boolean
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
  languages = [],
  color = 'white',
  menuItem = false,
}) => {
  const { t } = useTranslation()
  const { changeLocale } = useLocaleChange()

  const textColor = color === 'black' ? 'text-black' : 'text-white'

  return (
    <div className={cn('flex', textColor)}>
      {languages.map((lang, index) =>
        menuItem ? (
          <DropdownMenuItem
            key={index}
            className="w-full cursor-pointer"
            onClick={() => changeLocale(lang)}
          >
            {t('switcher')}
          </DropdownMenuItem>
        ) : (
          <Button
            key={index}
            variant={'link'}
            onClick={() => changeLocale(lang)}
            className={cn(textColor)}
          >
            {t('switcher')}
          </Button>
        ),
      )}
    </div>
  )
}

export { LanguageSwitcher }
